import React from 'react'
import { Link } from 'react-router-dom'
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube
} from 'react-icons/fa'

const navigation = {
  main: [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Personal Data Protection', href: '/personal-data-declaration' },
  ],
  social: [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/talentfinderconsulting',
      icon: FaFacebook
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/talentfinderconsulting/',
      icon: FaInstagram
    },
    {
      name: 'Twitter',
      href: 'https://x.com/talentfindertr',
      icon: FaTwitter
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/81917889/',
      icon: FaLinkedin
    },
    {
      name: 'YouTube',
      href: 'https://www.youtube.com/@TalentFinder-TR',
      icon: FaYoutube
    }
  ]
}

export default function Footer() {
  return (
    <footer className="bg-[#592C81] mt-26" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8">
        <nav className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
          {navigation.main.map((item) => (
            <div key={item.name} className="pb-6">
              <Link
                to={item.href}
                className="text-sm leading-6 text-white hover:text-gray-200"
              >
                {item.name}
              </Link>
            </div>
          ))}
        </nav>
        <div className="mt-10 flex justify-center space-x-10">
          {navigation.social.map((item) => (
            <Link key={item.name} to={item.href} className="text-white hover:text-gray-200">
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </Link>
          ))}
        </div>
        <p className="mt-20 text-center text-xs leading-5 text-white">
          &copy; {new Date().getFullYear()} Talent Finder Consulting. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
